module.exports = __webpack_public_path__ + "img/logo-travelcab-desktop.cd782ef5.svg";